// Move the decimal point instead of multiplying floats or rounding configured rates.
export function formatRatePercent(value) {
  const raw = String(value == null || value === '' ? 0 : value).trim();
  const match = raw.match(/^([+-]?)(\d+)(?:\.(\d*))?(?:e([+-]?\d+))?$/i);
  if (!match || !Number.isFinite(Number(raw))) return '0%';
  const digits = match[2] + (match[3] || '');
  const point = match[2].length + Number(match[4] || 0) + 2;
  let result;
  if (point <= 0) result = '0.' + '0'.repeat(-point) + digits;
  else if (point >= digits.length) result = digits + '0'.repeat(point - digits.length);
  else result = digits.slice(0, point) + '.' + digits.slice(point);
  const parts = result.split('.');
  const whole = parts[0].replace(/^0+(?=\d)/, '');
  const fraction = (parts[1] || '').replace(/0+$/, '');
  result = whole + (fraction ? '.' + fraction : '');
  return (match[1] === '-' && result !== '0' ? '-' : '') + result + '%';
}
